import React from 'react';
import type { NewsItem } from '../../../types/news';
import { formatDate } from '../../../utils/date';
import { getSnippet } from '../../../utils/news';
import styles from './NewsListItem.module.scss';

interface NewsListItemProps {
    item: NewsItem;
    isActive: boolean;
    onSelect: (id: string) => void;
}

export function NewsListItem({ item, isActive, onSelect }: NewsListItemProps) {
    return (
        <button
            type="button"
            className={isActive ? `${styles.item} ${styles.isActive}` : styles.item}
            aria-current={isActive ? 'true' : undefined}
            onClick={() => onSelect(item.id)}
        >

            <span className={styles.title}>{item.title}</span>
            <span className={styles.snippet}>{getSnippet(item)}</span>
        </button>
    );
}
